











































































































































































































import {
  defineComponent,
  ref,
  onMounted,
  useFetch,
  onBeforeUnmount,
  computed,
  nextTick,
  PropType,
  useContext,
  useRouter,
  useRoute,
  useFetchState,
  watch
} from '~/utils/nuxt3-migration'
import vClickOutside from 'v-click-outside'
import { ciMagnifyingGlass } from '~/icons/source/solid/magnifying-glass'
import { ciTimes } from '~/icons/source/regular/times'
import { useI18n } from '~/compositions/i18n'
import SearchbarService from '~/services/search-bar/SearchbarService'
import { useDep } from '~/compositions/dependency-container'
import { CategoryId } from '~/models/category/types'
import { debounce } from '~/utils/function'
import { DEBOUNCE_SLOW } from '~/constants/debounce'
import { KeyCode } from '~/constants/keyboard'
import { useUserAgent } from '~/compositions/user-agent'
import { useModalToggle } from '~/compositions/modal-toggle'
import CMicrophoneRecorder from '~/components/shared/configurable/CMicrophoneRecorder.vue'
import { defineComponentTranslations } from '~/utils/i18n'
import qs from 'qs'
import { ciAngleLeftLight } from '~/icons/source/solid/angle-left-light'
import { isCancelError } from '~/utils/http'
import { useLogger } from '~/compositions/logger'
import {
  SmartAction,
  SmartActionResult,
  SmartAutocompleteResult,
  SmartAutocompletion,
  SmartClassifiedResult,
  SmartInsightResult,
  SmartResultSection
} from '~/models/search-bar'
import SmartSearchbarAutocompleteSuggestion from '~/components/shared/classified/search/searchbar/smart-suggestions/SmartSearchbarAutocompleteSuggestion.vue'
import SmartSearchbarActionSuggestion from '~/components/shared/classified/search/searchbar/smart-suggestions/SmartSearchbarActionSuggestion.vue'
import SmartSearchbarClassifiedSuggestion from '~/components/shared/classified/search/searchbar/smart-suggestions/SmartSearchbarClassifiedSuggestion.vue'
import SmartSearchbarResultSection from '~/components/shared/classified/search/searchbar/SmartSearchbarResultSection.vue'
import { useNamespacedStore } from '~/compositions/store'
import {
  CLASSIFIED_SEARCH_NS,
  SearchState
} from '~/store/modules/shared/classifieds/search/state'
import SearchbarInCategoryButtons from '~/components/shared/classified/search/searchbar/SearchbarInCategoryButtons.vue'

export default defineComponent({
  components: {
    SearchbarInCategoryButtons,
    SmartSearchbarResultSection,
    SmartSearchbarClassifiedSuggestion,
    SmartSearchbarActionSuggestion,
    SmartSearchbarAutocompleteSuggestion,
    CMicrophoneRecorder
  },
  directives: {
    clickOutside: vClickOutside.directive
  },
  props: {
    placeholder: {
      type: String,
      default: ''
    },
    maxLength: {
      type: Number,
      required: false,
      default: 150
    },
    forceCategory: {
      type: Number as PropType<CategoryId>,
      required: false,
      default: undefined
    },
    inIndex: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  setup(props, { emit }) {
    const hasMic = ref(false)
    const focused = ref(false)
    const silentlyFocused = ref(false)
    const activePlaceholder = ref(0)
    const micRecording = ref(false)
    const activeQ = useFetchState('activeQ', ref(''))
    const searchQ = useFetchState('searchQ', ref(''))
    const activeDisplayPhrase = useFetchState('activeDisplayPhrase', ref(''))
    const linkToNavigate = ref('')
    const rightColumnIndexToNavigate = ref(-1)
    const classifiedIndexToNavigate = ref(-1)
    const fadePlaceholder = ref(false)
    const dontFetchNextInput = ref(false)
    const dontFetchNextFocus = ref(false)
    const fetchingAutocomplete = ref(false)
    const fetchingActions = ref(false)
    const fetchingClassifieds = ref(false)
    const fetchingInsight = ref(false)
    const fullscreen = ref(false)
    const suggestAfterFetch = ref(false)
    const activeSuggestionIndex = ref(-1)
    const hoveredSuggestion = ref(-1)
    const placeholderInterval = ref(null)
    const activeSuggestion = ref(null)
    const inCategory = ref(!props.inIndex)
    const backendPlaceholders = ref<string[]>([])
    const autocompleteSuggestions = ref<SmartAutocompleteResult[]>([])
    const actionSuggestions = ref<SmartActionResult[]>([])
    const classifiedSuggestions = ref<SmartClassifiedResult[]>([])
    const insightSuggestions = ref<SmartInsightResult[]>([])
    const rightColumnRefs = ref<
      (InstanceType<typeof SmartSearchbarResultSection> | null)[]
    >([])
    const searchbarRef = ref(null)
    const suggestionsRef = ref(null)

    const { t } = useI18n()
    const router = useRouter()
    const logger = useLogger()
    const route = useRoute()
    const { isMobile } = useUserAgent()
    const searchbarService = useDep(SearchbarService)
    const modalToggleFunc = useModalToggle()

    const { $cache: cache } = useContext()

    const {
      state: classifiedSearchState,
      getters: classifiedSearchGetters,
      dispatch: classifiedSearchDispatch
    } = useNamespacedStore<SearchState>(CLASSIFIED_SEARCH_NS)

    watch(fullscreen, val => {
      emit('fullscreen-state', val)
    })

    const getSetting = classifiedSearchGetters('getSetting')
    const inSearchRoute = computed(() => {
      return (
        route.value.name?.startsWith('__classifieds_search') ||
        getSetting('isDealerSiteSearch')
      )
    })

    const context = computed(() => {
      if (inSearchRoute.value && classifiedSearchState.query?.myclassifieds) {
        return 'myclassifieds'
      }
      return undefined
    })

    const clickedOutside = () => {
      if (fullscreen.value) {
        disableFullscreen()
      }
      closeSuggestions()
    }

    const focusSearchbar = async () => {
      await nextTick()
      if (searchbarRef.value) {
        searchbarRef.value.focus()
      }
    }

    const onActionSuggestionClick = (suggestion: any, index: number) => {
      /* eslint-disable no-console */
      console.log('onActionSuggestionClick', suggestion, index)
    }
    const onAutocompleteSuggestionClick = (suggestion: any, index: number) => {
      /* eslint-disable no-console */
      console.log('onAutocompleteSuggestionClick', suggestion, index)
    }
    const onSuggestedClassifiedClick = (index: number) => {
      /* eslint-disable no-console */
      console.log('onAutocompleteSuggestionClick', index)
    }

    const onEnter = async () => {
      if (activeSuggestionIndex.value >= 0 && activeSuggestion.value) {
        switch (activeSuggestion.value.type) {
          case 'action': {
            onActionSuggestionClick(
              activeSuggestion.value,
              activeSuggestionIndex.value
            )
            break
          }
          case 'autocomplete': {
            onAutocompleteSuggestionClick(
              activeSuggestion.value,
              activeSuggestionIndex.value
            )
            break
          }
          case 'classified': {
            onSuggestedClassifiedClick(activeSuggestionIndex.value)
            break
          }
        }
        blurSearchbar()
      } else {
        dontFetchNextInput.value = true
        if (activeDisplayPhrase.value === '') {
          closeSuggestions()
        } else {
          await suggestActiveDisplayPhrase()
        }
        blurSearchbar()
      }

      if (fullscreen.value) {
        disableFullscreen()
      }
    }

    const suggestActiveDisplayPhrase = async () => {
      if (activeDisplayPhrase.value) {
        if (fetchingActions.value) {
          // we are already fetching a query so when this is finished
          suggestAfterFetch.value = true
        } else {
          try {
            suggestAfterFetch.value = true
            await fetchActionSuggestions(activeDisplayPhrase.value)
          } catch (error) {
            logger.captureError(error)
          }
        }
      }
    }

    const leftColumnSections = computed<SmartResultSection[]>(() => {
      let formattedActions = []
      if (fetchingActions.value) {
        formattedActions = [
          {
            title: '',
            type: 'action',
            suggestions: [],
            fetching: true,
            tags: []
          }
        ]
      } else {
        formattedActions = actionSuggestions.value.map(
          (action: SmartActionResult) => {
            return {
              title: action.title || '',
              type: 'action',
              suggestions: action.actions,
              fetching: fetchingActions.value,
              tags: action.tags || []
            }
          }
        )
      }

      let formattedAutocompletes = []
      if (fetchingAutocomplete.value) {
        formattedAutocompletes = [
          {
            title: '',
            type: 'autocomplete',
            suggestions: [],
            fetching: true,
            tags: []
          }
        ]
      } else {
        formattedAutocompletes = autocompleteSuggestions.value.map(
          (autocomplete: SmartAutocompleteResult) => {
            return {
              title: autocomplete.title || '',
              type: 'autocomplete',
              suggestions: autocomplete.completions,
              fetching: fetchingAutocomplete.value,
              tags: autocomplete.tags || []
            }
          }
        )
      }

      let formattedInsights = []
      if (
        (!fullscreen.value &&
          !fetchingAutocomplete.value &&
          formattedAutocompletes.length) ||
        (!fetchingActions.value && formattedActions.length)
      ) {
        formattedInsights = insightSuggestions.value.map(
          (insight: SmartInsightResult) => {
            return {
              title: insight.title || '',
              type: 'insight',
              suggestions: [],
              content: insight.content,
              fetching: fetchingInsight.value,
              tags: insight.tags || []
            }
          }
        )
      }

      return [
        ...formattedActions,
        ...formattedAutocompletes,
        ...formattedInsights
      ]
    })

    const rightColumnSections = computed<SmartResultSection[]>(() => {
      let formattedClassifieds = []
      if (fetchingClassifieds.value) {
        formattedClassifieds = [
          {
            title: '',
            type: 'classified',
            suggestions: [],
            fetching: true,
            tags: []
          }
        ]
      } else {
        formattedClassifieds = classifiedSuggestions.value.map(
          (classified: SmartClassifiedResult) => {
            return {
              title: classified.title || '',
              type: 'classified',
              suggestions: classified.classifieds,
              fetching: fetchingClassifieds.value,
              tags: classified.tags || []
            }
          }
        )
      }

      let formattedInsights = []
      if (
        (leftColumnSections.value.length === 0 || fullscreen.value) &&
        !fetchingClassifieds.value &&
        formattedClassifieds.length
      ) {
        formattedInsights = insightSuggestions.value.map(
          (insight: SmartInsightResult) => {
            return {
              title: insight.title || '',
              type: 'insight',
              suggestions: [],
              content: insight.content,
              fetching: fetchingInsight.value,
              tags: insight.tags || []
            }
          }
        )
      }

      return [...formattedClassifieds, ...formattedInsights]
    })

    const currentCategoryId = computed(
      () => classifiedSearchState?.category?.id
    )

    const selectedCategory = computed(() => {
      if (inCategory.value && currentCategoryId.value) {
        return currentCategoryId.value
      }
      return props.forceCategory || CategoryId.PLOT
    })
    const searchbarPlaceholder = computed(() => {
      return props.placeholder || t('what_property_looking_for')
    })

    const placeholders = computed(() => {
      return [searchbarPlaceholder.value, ...backendPlaceholders.value]
    })

    const placeholderToShow = computed(() => {
      if (micRecording.value) {
        return t('start talking') + '...'
      }

      if (placeholders.value.length > 1) {
        const indexToShow =
          focused.value && !silentlyFocused.value ? 0 : activePlaceholder.value
        const prefix = indexToShow > 0 ? `${t('e.g.').toLowerCase()} ` : ''
        return prefix + placeholders.value[indexToShow]
      }

      return searchbarPlaceholder.value
    })

    const fetching = computed(() => {
      return (
        fetchingAutocomplete.value ||
        fetchingActions.value ||
        fetchingInsight.value ||
        fetchingClassifieds.value
      )
    })

    const showResults = computed(() => {
      return Boolean(
        fetching.value ||
          autocompleteSuggestions.value.length ||
          actionSuggestions.value.length ||
          classifiedSuggestions.value.length
      )
    })

    const setFinalQuote = async q => {
      if (q) {
        micRecording.value = false
        activeQ.value = q
        await nextTick()
        onInput()
      }
    }
    const setInterimQuote = async q => {
      if (q) {
        activeQ.value = q
        await nextTick()
        onInput()
      }
    }
    const setMicRecStatus = (status: boolean) => {
      micRecording.value = status
    }

    const onInput = () => {
      // acts like vmodel but also works on mobile when input is changing
      activeQ.value = searchbarRef.value.value
      searchQ.value = activeQ.value as string
      activeDisplayPhrase.value = activeQ.value
      triggerAutocomplete()
    }

    const triggerAutocomplete = debounce(async () => {
      if (dontFetchNextInput.value) {
        dontFetchNextInput.value = false
      } else {
        await closeSuggestions()
        fetchSuggestions(searchQ.value)
      }
    }, DEBOUNCE_SLOW)

    const closeSuggestions = async () => {
      if (fetching.value) {
        await searchbarService.cancelRequests()

        // they just got cancelled and for some reason 'finally' does not run instantly after cancel
        fetchingAutocomplete.value = false
        fetchingActions.value = false
        fetchingInsight.value = false
        fetchingClassifieds.value = false

        cache.reset()
      }

      activeSuggestion.value = null
      if (autocompleteSuggestions.value.length) {
        autocompleteSuggestions.value = []
      }

      if (actionSuggestions.value.length) {
        actionSuggestions.value = []
      }
      if (classifiedSuggestions.value.length) {
        classifiedSuggestions.value = []
      }

      activeSuggestionIndex.value = -1
      hoveredSuggestion.value = -1
      emit('suggestions-close', activeQ.value)
    }

    const fetchSuggestions = async (q: string) => {
      fetchAutocompleteSuggestions(q)
      fetchingClassifieds.value = true // to trigger the shimmers
      await fetchActionSuggestions(q)
      fetchClassifiedSuggestions(q)
      fetchInsightSuggestions(q)
    }

    const fetchAutocompleteSuggestions = async (q: string) => {
      try {
        fetchingAutocomplete.value = true

        const suggestions = await searchbarService.getSmartAutocompleteSuggestions(
          q,
          selectedCategory.value,
          context.value
        )

        if (autocompleteSuggestions.value.length) {
          autocompleteSuggestions.value = []
        }
        activeSuggestionIndex.value = -1
        hoveredSuggestion.value = -1

        autocompleteSuggestions.value = suggestions
      } catch (error) {
        if (!isCancelError(error)) {
          // logger.captureError(error)
        }
      } finally {
        fetchingAutocomplete.value = false
      }
    }

    const fetchActionSuggestions = async (q: string) => {
      if (fetchingActions.value) {
        return
      }
      try {
        fetchingActions.value = true

        const actions = await searchbarService.getSmartActionSuggestions(
          q,
          selectedCategory.value,
          context.value
        )

        if (suggestAfterFetch.value) {
          await nextTick()
          suggestAfterFetch.value = false
          if (actions.length && actions[0].actions.length) {
            onActionClick(actions[0].actions[0])
          }
        } else {
          actionSuggestions.value = actions
          // backend requested to refetch classifieds here
          // fetchClassifiedSuggestions(q)
        }
      } catch (error) {
        if (!isCancelError(error)) {
          // logger.captureError(error)
        }
      } finally {
        fetchingActions.value = false
      }
    }

    const fetchClassifiedSuggestions = async (q: string) => {
      try {
        fetchingClassifieds.value = true

        const suggestions = await searchbarService.getSmartClassifiedSuggestions(
          q,
          selectedCategory.value,
          context.value
        )

        if (classifiedSuggestions.value.length) {
          classifiedSuggestions.value = []
        }

        classifiedSuggestions.value = suggestions
      } catch (error) {
        if (!isCancelError(error)) {
          // logger.captureError(error)
        }
      } finally {
        fetchingClassifieds.value = false
      }
    }

    const fetchInsightSuggestions = async (q: string) => {
      try {
        fetchingInsight.value = true

        if (insightSuggestions.value.length) {
          insightSuggestions.value = []
        }

        const suggestions = await searchbarService.getSmartInsightSuggestions(
          q,
          selectedCategory.value,
          context.value
        )

        insightSuggestions.value = suggestions
      } catch (error) {
        if (!isCancelError(error)) {
          // logger.captureError(error)
        }
      } finally {
        fetchingInsight.value = false
      }
    }

    const onDown = (e: KeyboardEvent) => {
      /* eslint-disable no-console */
      console.log('onDown', e)
    }
    const onUp = (e: KeyboardEvent) => {
      /* eslint-disable no-console */
      console.log('onDown', e)
    }

    const blurSearchbar = async () => {
      await nextTick()
      if (searchbarRef.value) {
        searchbarRef.value.blur()
      }
    }
    const onKeydown = (e: KeyboardEvent) => {
      if (
        autocompleteSuggestions.value.length === 0 ||
        actionSuggestions.value.length === 0 ||
        classifiedSuggestions.value.length === 0
      ) {
        return
      }

      const key = e.keyCode

      switch (key) {
        case KeyCode.DOWN:
          onDown(e)
          break
        case KeyCode.UP:
          onUp(e)
          break
        case KeyCode.ESC:
          e.preventDefault()
          closeSuggestions()
          blurSearchbar()
          break
      }
    }

    const onBlur = () => {
      focused.value = false
    }

    const onFocus = () => {
      focused.value = true

      if (dontFetchNextInput.value) {
        dontFetchNextInput.value = false
      }

      if (dontFetchNextFocus.value) {
        dontFetchNextFocus.value = false
        return
      }

      // if it is mobile, show suggestions as modal
      if (isMobile.value) {
        fullscreen.value = true
        modalToggleFunc.modalOpen()

        if (suggestionsRef.value) {
          suggestionsRef.value.scrollTop = 0
        }
      }
      fetchSuggestions(activeQ.value)
    }

    const onClick = () => {
      if (!isMobile.value && silentlyFocused.value && !showResults.value) {
        silentlyFocused.value = false
        onFocus()
      }
    }

    const silentFocus = () => {
      dontFetchNextFocus.value = true
      silentlyFocused.value = true
      focusSearchbar()
    }

    const clearQ = () => {
      closeSuggestions()
      activeQ.value = ''
      activeDisplayPhrase.value = ''
      if (!isMobile.value) {
        dontFetchNextFocus.value = true
      }
      focusSearchbar()
    }

    const showInCategory = computed(() => {
      if (props.inIndex) {
        return false
      }
      return !classifiedSearchGetters('inRootCategory')
    })

    const updateActiveQFromUrl = async (path: string = '') => {
      await nextTick()
      const pathToUse = path || window.location.search
      const { activeq } = qs.parse(pathToUse, {
        ignoreQueryPrefix: true
      })
      if (activeq) {
        activeQ.value = activeq
      }

      if (activeQ.value) {
        searchQ.value = activeQ.value
        activeDisplayPhrase.value = activeQ.value
      }
    }

    const onGlobalKeyDown = (e: KeyboardEvent) => {
      const key = e.keyCode
      if (key === KeyCode.SLASH) {
        const focusElem = document.activeElement
        const elemType = focusElem.type
        if (
          focusElem.tagName.toLowerCase() === 'input' &&
          [
            'text',
            'search',
            'email',
            'number',
            'password',
            'tel',
            'url'
          ].includes(elemType)
        ) {
          // focus is on an input text element
          return
        }
        e.preventDefault()
        focusSearchbar()
        window.scrollTo(0, 0)
      }
    }

    const addGlobalKeyDownListener = () => {
      document.addEventListener('keydown', onGlobalKeyDown)
    }

    const removeGlobalKeyDownListener = () => {
      document.removeEventListener('keydown', onGlobalKeyDown)
    }

    const nextActivePlaceholder = () => {
      if (focused.value && !silentlyFocused.value) {
        return
      }
      fadePlaceholder.value = true
      setTimeout(() => {
        if (activePlaceholder.value + 1 > placeholders.value.length - 1) {
          activePlaceholder.value = 0
        } else {
          activePlaceholder.value++
        }
        fadePlaceholder.value = false
      }, 300) // 300 = same as the declared css transition time
    }

    const placeholdersCheck = async () => {
      // reset in case they are already set
      activePlaceholder.value = 0
      clearInterval(placeholderInterval.value)

      await nextTick()
      if (placeholders.value.length > 1) {
        const delay = 4000
        placeholderInterval.value = setInterval(nextActivePlaceholder, delay)
      }
    }

    const afterModalClose = async () => {
      blurSearchbar()
      if (linkToNavigate.value) {
        const link = linkToNavigate.value
        linkToNavigate.value = ''

        await navigateToFinalUrl(link)

        updateActiveQFromUrl(link)
      }

      if (
        classifiedIndexToNavigate.value > -1 &&
        rightColumnIndexToNavigate.value > -1
      ) {
        const rIndex = rightColumnIndexToNavigate.value
        const clsfdIndex = classifiedIndexToNavigate.value

        rightColumnIndexToNavigate.value = -1
        classifiedIndexToNavigate.value = -1

        if (clsfdIndex > -1 && rIndex > -1) {
          triggerClassifiedAtIndex(rIndex, clsfdIndex)
        }
      }
    }

    const disableFullscreen = () => {
      modalToggleFunc.modalClose(false)
    }

    const mobileBackClicked = () => {
      disableFullscreen()
      closeSuggestions()
    }

    const onModalClose = () => {
      fullscreen.value = false
      focused.value = false
    }

    const getUrlWithActiveQ = (path: string) => {
      const fullUrl = new URL(path, window.location.origin)

      if (activeQ.value) {
        fullUrl.searchParams.set('activeq', activeQ.value)
      } else {
        fullUrl.searchParams.delete('activeq')
      }

      return fullUrl.pathname + fullUrl.search
    }

    const goToUrl = async (url: string, addActiveQ = false) => {
      if (!url) {
        return
      }

      let finalUrl = url
      if (addActiveQ) {
        finalUrl = getUrlWithActiveQ(url)
      }

      if (fullscreen.value) {
        closeSuggestions()
        linkToNavigate.value = finalUrl
        blurSearchbar()
        disableFullscreen()
      } else {
        blurSearchbar()
        if (isMobile.value) {
          disableFullscreen()
        }

        await navigateToFinalUrl(finalUrl)
      }
    }

    const navigateToFinalUrl = async (finalUrl: string) => {
      if (!finalUrl) {
        return
      }

      closeSuggestions()

      if (finalUrl.startsWith('/classifieds/new')) {
        window.location.href = finalUrl
      } else if (inSearchRoute.value) {
        await classifiedSearchDispatch('loadSeoUrlSearch', {
          seoUrl: finalUrl
        })
      } else {
        await router
          .push({
            path: finalUrl
          })
          .catch(_e => {})
      }
    }

    const onAutocompletionClick = (completion: SmartAutocompletion) => {
      activeQ.value = completion.query
      searchQ.value = activeQ.value
      activeDisplayPhrase.value = activeQ.value

      // await closeSuggestions()
      fetchSuggestions(searchQ.value)
    }

    const onActionClick = (action: SmartAction) => {
      if (action.url) {
        goToUrl(action.url)
      }
    }

    const onClassifiedClick = (rightColumnIndex: number, index: number) => {
      if (fullscreen.value) {
        rightColumnIndexToNavigate.value = rightColumnIndex
        classifiedIndexToNavigate.value = index
        blurSearchbar()
        disableFullscreen()
        closeSuggestions()
      } else {
        triggerClassifiedAtIndex(rightColumnIndex, index)
      }
    }
    const triggerClassifiedAtIndex = (
      rightColumnIndex: number,
      index: number
    ) => {
      if (rightColumnRefs.value[rightColumnIndex]) {
        rightColumnRefs.value[rightColumnIndex].triggerClassifiedAtIndex(index)
      }
    }

    useFetch(() => {
      if (route.value.query.activeq) {
        activeQ.value = route.value.query.activeq
        searchQ.value = activeQ.value
        activeDisplayPhrase.value = activeQ.value
      }
    })

    const fetchBackendPlaceholders = async () => {
      try {
        const {
          placeholders: fetchedPlaceholders
        } = await searchbarService.getSmartSearchbarPlaceholders()
        backendPlaceholders.value = fetchedPlaceholders

        placeholdersCheck()
      } catch (_e) {}
    }

    const showOverlay = computed(() => {
      if (fullscreen.value || props.inIndex) {
        return false
      }
      return showResults.value || focused.value
    })

    const roundedClass = computed(() => {
      if (fullscreen.value && showInCategory.value) {
        return ''
      }
      return props.inIndex ? 'tw-rounded-xl' : 'tw-rounded-lg'
    })

    onMounted(() => {
      cache.reset()
      updateActiveQFromUrl()
      fetchBackendPlaceholders()

      if (!isMobile.value) {
        addGlobalKeyDownListener()
      }

      modalToggleFunc.setModalInSearch(!props.inIndex)
      modalToggleFunc.setHash('searchbar')
      modalToggleFunc.setAfterModalCloseCallback(afterModalClose)
      modalToggleFunc.setOnModalCloseCallback(onModalClose)

      if (searchbarRef.value === document.activeElement) {
        onFocus()
      }
    })

    onBeforeUnmount(() => {
      cache.reset()
      removeGlobalKeyDownListener()
      clearInterval(placeholderInterval.value)
    })

    return {
      clickedOutside,
      hasMic,
      searchbarRef,
      suggestionsRef,
      focused,
      focusSearchbar,
      onEnter,
      activeQ,
      searchQ,
      fadePlaceholder,
      placeholderToShow,
      selectedCategory,
      onInput,
      micRecording,
      activeSuggestionIndex,
      setFinalQuote,
      setInterimQuote,
      setMicRecStatus,
      onKeydown,
      fetching,
      fullscreen,
      onBlur,
      onFocus,
      onClick,
      clearQ,
      silentFocus,
      showResults,
      isMobile,
      autocompleteSuggestions,
      actionSuggestions,
      classifiedSuggestions,
      insightSuggestions,
      onActionClick,
      mobileBackClicked,
      disableFullscreen,
      onAutocompletionClick,
      rightColumnRefs,
      onClassifiedClick,
      leftColumnSections,
      rightColumnSections,
      backendPlaceholders,
      placeholders,
      inCategory,
      showInCategory,
      currentCategoryId,
      showOverlay,
      roundedClass,
      context,
      ciMagnifyingGlass,
      ciAngleLeftLight,
      ciTimes
    }
  },
  i18n: defineComponentTranslations({
    what_property_looking_for: {
      en: 'What property are you looking for?',
      el: 'Τι ακίνητο ψάχνεις;'
    }
  })
})
